import { Timestamp } from 'firebase/firestore';

export interface HelpArticle {
  id: string;
  title: string;
  content: string;
  category: string; // e.g., 'getting-started', 'email-campaigns', 'automations', 'contacts', 'integrations', 'account-billing'
  url?: string; // Optional URL for external links
  slug: string; // URL-friendly identifier
  order: number; // Display order within category
  isActive: boolean;
  isFeatured: boolean; // Show in suggested questions
  tags: string[]; // For search and filtering
  views: number; // Track article views
  helpfulCount: number; // Track helpful votes
  createdAt: Timestamp;
  updatedAt: Timestamp;
  createdBy: string; // User ID who created it
  updatedBy?: string; // User ID who last updated it
}

export interface HelpArticleFormData {
  title: string;
  content: string;
  category: string;
  url?: string;
  slug: string;
  order: number;
  isActive: boolean;
  isFeatured: boolean;
  tags: string[];
}

export const HELP_CATEGORIES = [
  { id: 'getting-started', name: 'Getting Started', icon: '🚀' },
  { id: 'email-campaigns', name: 'Email Campaigns', icon: '📧' },
  { id: 'automations', name: 'Automations & Workflows', icon: '🤖' },
  { id: 'contacts', name: 'Contacts & Segments', icon: '👥' },
  { id: 'integrations', name: 'Integrations', icon: '🔗' },
  { id: 'account-billing', name: 'Account & Billing', icon: '💳' },
] as const;

export type HelpCategoryId = typeof HELP_CATEGORIES[number]['id'];

